import { useOutletContext } from "react-router-dom";
import TINNRLayout from "../type";
import TOutletContext from "@/cms/types/TOutletContext";
import { useEffect } from "react";
import { metaDataLanguageVersion, outerNameDescriptionLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";
import ContactForm from "@/components/ContactForm";
import PageBanner from "@/components/PageBanner";
import { isEmpty } from "lodash";
import EResourceType from "@/cms/enums/EResourceType";
import RMDRImage from "@/components/RMDRImage";
import ContentRenderer from "@/components/ContentRenderer";


const INNR_002 = ( props:TINNRLayout ) => {

    const { siteSettingPayload, _showLoader, _hideLoader } = useOutletContext<TOutletContext>();

    useEffect(
        () => {
            setTimeout(() => { _hideLoader(); }, 100);
            return () => {
                _showLoader();
            }
        },[]
    )
    
    if ( !props.contentDetailPayload?.languageVersions || isEmpty(props.contentDetailPayload?.languageVersions) ) return null;

    const languageVersion = outerNameDescriptionLanguageVersion(props.contentDetailPayload.languageVersions);
    const pageContactFormHeader = metaDataLanguageVersion("pageContactFormHeader", siteSettingPayload.languageVersions);
    const pageContactFormDescription = metaDataLanguageVersion("pageContactFormDescription", siteSettingPayload.languageVersions);

    return (
        <>
            <PageBanner title={languageVersion?.name} resources={props.contentDetailPayload.resources} resourceType={EResourceType.PARALLAX} />
            <div className="about-area ptb-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 col-md-12">
                            <div className="about-image">
                                <RMDRImage
                                    resourceType={EResourceType.INNER_IMAGE} 
                                    resources={props.contentDetailPayload?.resources} 
                                    alt={languageVersion?.name} 
                                    title={languageVersion?.name}
                                    className="h-auto rounded-10"
                                />
                            </div>
                        </div>

                        <div className="col-lg-7 col-md-12">
                            <div className="about-content about-content-two">
                                <div className="section-title">
                                    <ContentRenderer
                                        languageVersions={props.contentDetailPayload.languageVersions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="pb-100">
                <div className="contact-form">
                    <div className="contact-title">
                        <h2>{pageContactFormHeader}</h2>
                        <p>{pageContactFormDescription}</p>
                    </div>
                    <ContactForm allowSendURL />
                </div>
            </div>
      </>
    );
}

export default INNR_002;
